import React from 'react';

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

export function CMYKMark({ className = '', style }: Props) {
  return (
    <svg
      aria-hidden="true"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      style={style}
    >
      <line x1="16" y1="2" x2="16" y2="30" stroke="var(--ink-300)" strokeWidth="1" />
      <line x1="2" y1="16" x2="30" y2="16" stroke="var(--ink-300)" strokeWidth="1" />
      <circle cx="16" cy="16" r="6" stroke="var(--ink-300)" strokeWidth="1" fill="none" />
      <circle cx="16" cy="16" r="1.25" fill="var(--ink-500)" />
    </svg>
  );
}
